import { useMemo } from 'react';
import { isOrgOwner } from '@/utils/moduleAccess';
import { useAppSelector } from './useAppSelector';

export function usePermissions() {
  const user = useAppSelector((s) => s.auth.user);

  return useMemo(() => {
    const permissions = user?.permissions ?? [];
    const roleCode = user?.roleCode;
    const isMaster = user?.masterAdmin === true;
    const owner = isOrgOwner(permissions, roleCode);
    const has = (code: string) =>
      isMaster || owner || permissions.includes('MASTER_ADMIN') || permissions.includes(code);
    const hasAny = (...codes: string[]) => codes.some(has);
    const hasAll = (...codes: string[]) => codes.every(has);
    const isCashierOnly =
      !isMaster &&
      has('BILLING_CREATE') &&
      !has('ORG_MANAGE') &&
      !has('PRODUCT_MANAGE') &&
      !has('INVENTORY_MANAGE');
    return { permissions, roleCode, isMaster, has, hasAny, hasAll, isCashierOnly };
  }, [user]);
}
